import { render } from "./App.vue?vue&type=template&id=f4e4c140"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=f4e4c140&lang=css"

import exportComponent from "C:\\Users\\Oscar Daniel\\Desktop\\X LAUCHER\\TRABAJANDO\\05 - VUE\\Ejercio 2\\pasteleria-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__